import { Component, OnInit, ChangeDetectorRef, } from '@angular/core';
import { ViewChild, TemplateRef } from '@angular/core';
import { CdkDragDrop, moveItemInArray, transferArrayItem } from '@angular/cdk/drag-drop';
import { HttpEventType, HttpResponse } from '@angular/common/http';
import { Observable, Subscription } from 'rxjs';
import { timer } from 'rxjs';
import { FormGroup, FormBuilder } from '@angular/forms';
import { LoaderService } from 'src/app/middleware/shared/loader/loader.service';
import { ToastrService } from 'ngx-toastr';
import { StatusConstant } from 'src/app/middleware/common/status/status-constant';
import { ReusableClasses } from 'src/app/middleware/common/reusableclassesAndFunctions/reusable-classes';
import { MatDialog } from '@angular/material/dialog';
import { EncryptionService } from 'src/app/middleware/encryption/encryption.service';
declare var require: any;
const FileSaver = require('file-saver');
import * as jwt_decode from 'jwt-decode';
import { DataSharingService } from 'src/app/middleware/common/resuableServices/data-sharing.service';
import { FormsService } from '../services/forms.service';
import { Router } from '@angular/router';
import { FlatTreeControl } from '@angular/cdk/tree';
import { MatTreeFlatDataSource, MatTreeFlattener } from '@angular/material/tree';
import { ElementRef } from '@angular/core';
import { FileAction, FormTypes, ProjectTempType } from '../services/form.enum';

@Component({
  selector: 'app-step-one',
  templateUrl: './step-one.component.html',
  styleUrls: ['./step-one.component.scss'],
})

export class StepOneComponent implements OnInit {
  selected3cType: boolean = false;
  isProgressiveForm: boolean = false;
  currentUser: any;
  organizationId: string;
  databaseId: string;
  responseHolder: any;
  formDialog: FormGroup;
  selectedFiles: FileList;
  UploadingFiles = [];
  UploadingFilesCheckIfPDFConvert=[];
  UploadedFiles = [];
  ShowNextButton: boolean = false;
  editfilename = {
    id: 0,
    filename: '',
  };

  ResponseHolderDetails: any;
  formData: FormData = new FormData();
  prepareFilesToSaveInFirstStep: any = [];
  project: any;
  projectDocuments: any;
  clickEventsubscription: Subscription;
  FormFolderListMiddleSection: any = ([] = []);
  selectButtonShow: boolean = false;
  selectButtonMyDriveShow: boolean = false;
  PlaceholderName: string = "";
  filePath: string = "";
  fileSizeFromMyDrive: string = "";
  DocumentFolderID: string = "";
  FormID: string = "";
  FormFolderList: any;
  menuHeader: any = [];
  TypeId: number;
  parentID: number = 0;
  activeNode: string = "";
  hierarchyList: any;
  breadCrumMenu: any = [];
  FormsubFolderFolderList: any;


  MyDrivefoldersList: any;
  activeNodeFileManager: string = "";
  menuHeaderMyDrive: any = [];
  FileManagerFolderListLeft: any;
  fileManagerID: string = "";

  UploadedNewFiles: any = [];
  FileManagerDocuments: any = [];
  foldersMyDriveListShow: boolean = false;
  TransactionID: string = "0";
  TransactionType: string = "0";
  PlaceholderID: string = "0";

  modulename: string = "";
  projectName: any;
  projectNameExist: any;
  type: any;

  @ViewChild('projectnameadd') addprojectname: ElementRef;
  @ViewChild('Input') InputFile: ElementRef;
  @ViewChild('ReplaceInput') ReplaceInput: ElementRef;

  SharedWithMeFormFolderList: any = [] = [];
  isShowForm: any = true;
  isSharedWithMe: any = false;
  SharedWithMeactive: boolean = false;

  SharedWithMeMyDriveFolderList: any = [] = [];
  isShowMyDrive: any = false;
  isSharedWithMeMyDrive: any = false;
  SharedWithMeMyDriveactive: boolean = false;

  private _transformer = (node: FoodNode, level: number) => {
    return {
      expandable: !!node.children && node.children.length > 0,
      formFolderName: node.formFolderName,
      formFolderID: node.formFolderID,
      parentID: node.parentID,
      level: level,
      isShared: node.isShared
    };
  }

  private _transformerFileManager = (node: FoodNodeFileManager, level: number) => {
    return {
      expandable: !!node.children && node.children.length > 0,
      name: node.name,
      fileManagerItemID: node.fileManagerItemID,
      parentID: node.parentID,
      level: level,
      isShared: node.isShared
    };
  }

  treeControl = new FlatTreeControl<ExampleFlatNode>(node => node.level, node => node.expandable);
  treeFlattener = new MatTreeFlattener(this._transformer, node => node.level, node => node.expandable, node => node.children);
  dataSource = new MatTreeFlatDataSource(this.treeControl, this.treeFlattener);

  treeControlFileManager = new FlatTreeControl<ExampleFlatNodeFileManager>(node => node.level, node => node.expandable);
  treeFlattenerFileManager = new MatTreeFlattener(this._transformerFileManager, node => node.level, node => node.expandable, node => node.children);
  dataSourceFileManager = new MatTreeFlatDataSource(this.treeControlFileManager, this.treeFlattenerFileManager);


  hasChild = (_: number, node: ExampleFlatNode) => node.expandable;
  stepCompleted: number = 0;
  OfficeIDList: any = [];
  myOfficeID: any;
  Module: string = "";
  projectTempName: string = "";
  showImportTemplate: boolean = true;
  projectNameChange: boolean = false;
  TotalfileSize: number = 0;
  UploadedRuntimeFiles: any = [] = [];
  projectFormId: number = 0;
  isRemoveFile: boolean;
  menuModulesList: any = ([] = []);
  CoreShowName:string="";
 
  constructor(private formBuilder: FormBuilder, private loaderService: LoaderService,
    private toastr: ToastrService, private statusConst: StatusConstant,
    private reusableClass: ReusableClasses, private dialog: MatDialog,
    private encryptionAlgo: EncryptionService, private _dataSharingService: DataSharingService,
    private cdr: ChangeDetectorRef, private router: Router, private formService: FormsService) {
    const encryptedtoken = sessionStorage.getItem('userToken');
    const token = this.encryptionAlgo.get(this.reusableClass.encryptionKey, encryptedtoken);
    this.databaseId = sessionStorage.getItem('databaseId');
    this.organizationId = sessionStorage.getItem('organizationID');
    this.currentUser = jwt_decode(token);

    var offices = JSON.parse(sessionStorage.getItem('officeList'));
    offices.forEach(oe => {
      this.OfficeIDList.push(oe.officeID)
      if (oe.isMyoffice == true)
        this.myOfficeID = oe.officeID;
    });

  }

  ngAfterContentChecked() {
    this.cdr.detectChanges();
  }

  ngOnInit(): void {
    if (sessionStorage.getItem('stepCompleted') != undefined) {
      this.stepCompleted = Number(sessionStorage.getItem('stepCompleted'));
    }
    this.menuModulesList = JSON.parse(sessionStorage.getItem('menuModules'));
    var SelectedCore = [];    

    SelectedCore = this.menuModulesList.filter(
      (x) => x.mainModuleName == 'Core'
    );
    if (SelectedCore.length > 0) {
      this.CoreShowName = SelectedCore[0].orgModuleName;      
    }
    sessionStorage.setItem('ImportTemplateShow', 'true');
    this.UploadingFiles = [];
    this.UploadedFiles = [];
    let group = {};
    this.formDialog = new FormGroup(group);
    this.formDialog.addControl('filename', this.formBuilder.control(''));

    var menuModulesList = JSON.parse(sessionStorage.getItem("menuModules"));
    var Module = [];
    Module = menuModulesList.filter(x => x.mainModuleName == 'Forms');
    if (Module.length > 0) {
      this.Module = Module[0].orgModuleName;
    }

    sessionStorage.setItem('HeaderModuleName', this.Module);
    sessionStorage.setItem('edashboard', "false");

    if (sessionStorage.getItem('MasterTemplatePDFForm') == "true") {
      this.showImportTemplate = false;
    } else {
      this.showImportTemplate = true;
    }

    if (sessionStorage.getItem('type') == "1") {
      this.type = sessionStorage.getItem('type');
      sessionStorage.setItem('HeaderModuleName', this.Module);
      this.modulename = "Form";
      this.projectTempName = "Project";
      this._dataSharingService.sendSelectedModuleName(this.Module);
    }
    if (sessionStorage.getItem('type') == "2") {
      this.type = sessionStorage.getItem('type');
      sessionStorage.setItem('HeaderModuleName', 'Templates');
      this.modulename = "Template";
      this.projectTempName = "Template";
      this._dataSharingService.sendSelectedModuleName('Templates');
    }
    if (sessionStorage.getItem('projectID') !== null && sessionStorage.getItem('projectID') !== undefined && sessionStorage.getItem('projectID') !== '0') {
      this.GetProjectDocument(sessionStorage.getItem('projectID'), false);
    }

    if (sessionStorage.getItem('ProjectName') !== null && sessionStorage.getItem('ProjectName') !== undefined && sessionStorage.getItem('ProjectName') !== '0') {
      this.clickEventsubscription = this._dataSharingService.getFillPlaceholderDocumentForCore().subscribe((result) => {
        if (result) {
          this.FillPlaceHolderDocument(result);
        }
      });
    }

    this._dataSharingService.sendShowFormsSiderbar(this.Module);
    this.cdr.detectChanges();
  }

  showAllParticipant() {
    if (this.stepCompleted > 1)
      this.router.navigate(['/esignature/second']);
  }

  showFormEditor() {
    if (this.stepCompleted > 2)
      this.router.navigate(['/esignature/third']);
  }

  showFormFinish() {
    if (this.stepCompleted > 3)
      this.router.navigate(['/esignature/four']);
  }

  FillPlaceHolderDocument(result) {
    this.TransactionID = result.TransactionID;
    this.TransactionType = result.TransactionType;
    this.PlaceholderID = result.PlaceholderID;

    var DocumentList = [];
    DocumentList = result.Document;
    var ProjectName = result.Document.documentName.split('.');
    var ReqModel = {
      id: 0,
      fileName: ProjectName[0],//ProjectName[0].substring(0, 30), //ProjectName[0],//result.Document.documentName,
      // fileName: ProjectName[0].substring(0, 30), //ProjectName[0],//result.Document.documentName,
      base64: "",
      documentType: result.Document.fileType,
      documentPath: result.Document.documentPath,
      action: 0,
      isDeleted: 0,
      projectDocumentID: 0,
      file: "",
      pdfToImageStatus: '',
      FileManagerID: 0,
      FillPlaceHolder: true,
      Totalsize: result.Document.fileSize
    }
    this.UploadedFiles.push(ReqModel);
    this.UploadedNewFiles = this.UploadedFiles;
    this.ShowNextButton = true;
  }

  getReadableFileSizeString(fileSizeInBytes) {
    var i = -1;
    var byteUnits = [' KB', ' MB', ' GB', ' TB', 'PB', 'EB', 'ZB', 'YB'];
    do {
      fileSizeInBytes = fileSizeInBytes / 1024;
      i++;
    } while (fileSizeInBytes > 1024);

    return Math.max(fileSizeInBytes).toFixed(3) + byteUnits[i];
  };

  replaceClick() {
    var replacefileObj = document.getElementById('replacefile');
    if (replacefileObj) {
      replacefileObj.click();
    }
  }

  replaceDocumentId: number = 0;
  isReplaced: boolean = false;
  selectReplaceFile(event, existFile) {
    this.isReplaced = false;
    this.replaceDocumentId = 0;
    if(existFile.pageCount==undefined){
      existFile.pageCount=0;
    }
    let existingFilePageCount = existFile.pageCount;
    var reader = new FileReader();
    let file = (<HTMLInputElement>document.getElementById('replacefile')).files[0];
    const isPDF = file.name.toLocaleLowerCase().indexOf('.pdf') > -1;
    if (isPDF) {
      const fileNameLength = (file.name.split('.')[0]).length;
      if (fileNameLength > 120) {
        this.toastr.warning('File name upto 120 characters only supported, please rename file.', '', {
          timeOut: 3000,
        });
      } else {
        reader.readAsBinaryString(file);
        reader.onloadend = () => {
          let count = (reader.result as string).match(/\/Type[\s]*\/Page[^s]/g).length;
          let state = count >= existingFilePageCount;
          if (state) {
            const TotalFSize = Math.round((file.size / 1024 / 1024));
            const sizeState = TotalFSize > 5 ? false : true;
            if (sizeState) {
              this.deleteFileFromUploaded(existFile);
              this.isReplaced = true;
              this.replaceDocumentId = existFile.id;
              this.selectFiles(event);
            } else {
              this.ReplaceInput.nativeElement.value = '';
              this.toastr.warning('File too Big, please select a file less than 5MB.', '', {
                timeOut: 3000,
              });
            }
          } else {
            this.ReplaceInput.nativeElement.value = '';
            this.toastr.warning('New File Page count is less than existing file page count. Sorry we can\'t replace this file.', '', {
              timeOut: 3000,
            });
          }
        }
      }
    } else {
      this.ReplaceInput.nativeElement.value = '';
      this.toastr.warning('As of now we only support PDF documents', '', {
        timeOut: 3000,
      });
    }
  }
 
  loadAndProcessDefaultFile() {
    const filePath = '/assets/Blank_PDF.pdf'; // Path to your PDF in assets
    fetch(filePath,)
      .then(response => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        return response.blob();
      })
      .then(blob => {
        const file = new File([blob], 'Blank_PDF.pdf', { type: 'application/pdf' });
        let files={files:[file]}
        let event={target:files}
        this.selectFiles(event); // Process the file as needed
      })
      .catch(error => {
        console.error('There has been a problem with your fetch operation:', error);
      });
  }
  
  selectFiles(event) {
    this.UploadedRuntimeFiles = [];
    this.ShowNextButton = false;
    this.selectedFiles = event.target.files;
    this.TotalfileSize = 0;
    this.UploadedNewFiles;

    // If Allready Uploaded file and checking file size   
    this.UploadedRuntimeFiles = this.UploadedNewFiles.filter(x => x.action != FileAction.Delete);
    this.UploadedRuntimeFiles = this.UploadedRuntimeFiles.filter(x => x.pdfToImageStatus == null);
    if (this.UploadedRuntimeFiles.length > 0) {
      for (let i = 0; i < this.UploadedRuntimeFiles.length; i++) {
        // While File Compress and get new file size
        if (this.UploadedRuntimeFiles[i].size) {
          this.TotalfileSize += this.UploadedRuntimeFiles[i].size;  // get file size
        }
        // While uploading new file
        if (!this.UploadedRuntimeFiles[i].size) {
          this.TotalfileSize += this.UploadedRuntimeFiles[i].file.size; // get file size
        }
      }
    }
    // For new file uploading and checking file size
    if (this.selectedFiles.length > 0) {
      for (let i = 0; i < this.selectedFiles.length; i++) {
        this.TotalfileSize += this.selectedFiles[i].size; // get file size
      }
    }

    //const fsize = fi.files.item(i).size;
    // const TotalFSize = Math.round((this.TotalfileSize / 1024));
    const TotalFSize = Math.round((this.TotalfileSize / 1024 / 1024));
    //if(this.TotalfileSize > 2097152)
    // if(TotalFSize >= 2048)
    if (TotalFSize > 5) {
      this.toastr.warning('File too Big, please select a file less than 5MB.', '', {
        timeOut: 3000,
      });
      this.InputFile.nativeElement.value = '';
      this.ShowNextButton = true;
      return;
    }

    for (let i = 0; i < this.selectedFiles.length; i++) {
      var ext = this.selectedFiles[i].name.split('.').pop();
      // if (ext != 'pdf' && ext != 'png' && ext != 'jpg' && ext != 'jpeg') {
      //   alert('only pdf and image upload');
      //   return;
      // }

      if (ext.toLowerCase() != 'pdf') {
        this.toastr.warning('As of now we only support PDF documents', '', {
          timeOut: 3000,
        });
        return;
      }

      // //  const fsize = this.selectedFiles[i].size;
      // const filess = Math.round((TotalSize / 1024));
      // // The size of the file.
      //  if (filess >= 2048) {
      //   this.toastr.warning('File too Big, please select a file less than 2mb.', '', {
      //     timeOut: 3000,
      //   });
      //   return;
      //  }

      if (this.selectedFiles[i].name.split('.')[0].length > 120) {
        this.toastr.warning('File name upto 120 characters only supported, please rename file.', '', {
          timeOut: 3000,
        });
        return;
      }
      const file = event.target.files[i];

      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        var FullPath = this.selectedFiles[i].name;
        var documentNameSplit = FullPath.split('.');
        var documentName = documentNameSplit[0];
        // var documenttype = documentNameSplit[1];
        var documenttype = this.selectedFiles[i].name.split('.').pop();
        var isCompressed = false;
        var dynamicDocumentId = 0;
        // var size = this.selectedFiles[i].size;
        // documentName = documentName.substring(0, 30);//get first 30 chars

        var base64String = reader.result;
        var size = this.getReadableFileSizeString(this.selectedFiles[i].size);

        const checksizeFor1MB = Math.round((this.selectedFiles[i].size / 1024));
        // The size of the file.
        if (checksizeFor1MB >= 1024) {
          isCompressed = true;
          dynamicDocumentId = Math.floor(1000 + Math.random() * 9000);
        } else {
          isCompressed = false;
          dynamicDocumentId = 0;
        }

        documentName=documentName.replace(/[,\#\[\]\(\)\{\}<>\/\\\|\?\*\":;!@\$%^&=~`'+]/g, '');

        var ReqModel = {
          id: i + 1,
          fileName: documentName,
          progress: 0,
          base64: base64String,
          documentType: documenttype,
          action: 0,
          isDeleted: false,
          projectDocumentID: 0,
          file: this.selectedFiles[i],
          Totalsize: size,
          isCompressed: isCompressed,
          dynamicDocumentId: dynamicDocumentId
        };
        this.UploadingFiles.push(ReqModel);
        this.UploadingFilesCheckIfPDFConvert=[];
        this.UploadingFilesCheckIfPDFConvert.push(ReqModel);
       // this.CheckIfPDFWillConvertToImage();
        this.uploadFilesSimulator(0);

      };
    }

  }

  CheckIfPDFWillConvertToImage() {
   
    this.loaderService.show();
    this.formData= new FormData();

   

    for (let i = 0; i < this.UploadingFilesCheckIfPDFConvert.length; i++) {

      if (this.UploadingFilesCheckIfPDFConvert[i].file !== '' && this.UploadingFilesCheckIfPDFConvert[i].action == 0) {
        var FullPath = this.UploadingFilesCheckIfPDFConvert[i].file.name;
        var documentNameSplit = FullPath.split('.');
        var documentName = documentNameSplit[0];

        documentName=documentName.replace(/[,\#\[\]\(\)\{\}<>\/\\\|\?\*\":;!@\$%^&=~`'+]/g, '');

        // var documenttype = documentNameSplit[1];
        var documenttype = this.UploadingFilesCheckIfPDFConvert[i].file.name.split('.').pop();
        var documentOrder = this.UploadingFilesCheckIfPDFConvert[i].documentOrder;
        var documentpath = this.UploadingFilesCheckIfPDFConvert[i].documentPath ?? "";
        var documentsize = this.UploadingFilesCheckIfPDFConvert[i].Totalsize ?? "";
        let replaceDocId = this.UploadingFilesCheckIfPDFConvert[i].replaceDocumentId;
        // file region
        this.formData.append('files', this.UploadingFilesCheckIfPDFConvert[i].file);
        if(replaceDocId>0)
        {
          this.formData.append('filesData', documentName + '|' + documenttype + '|' + '7' + '|' + documentOrder + '|' + documentpath + '|' + documentsize + '|' + replaceDocId);
        }
        else
        {
          this.formData.append('filesData', documentName + '|' + documenttype + '|' + '0' + '|' + documentOrder + '|' + documentpath + '|' + documentsize + '|0');
        }
      }

      else if (this.UploadingFilesCheckIfPDFConvert[i].FileManagerID > 0 && this.UploadingFilesCheckIfPDFConvert[i].action == 0) {
        var documentName = this.UploadingFilesCheckIfPDFConvert[i].fileName;
        //var documenttype = this.UploadedFiles[i].documentType; 
        var documenttype = this.UploadingFilesCheckIfPDFConvert[i].fileName.split('.').pop();
        var documentOrder = this.UploadingFilesCheckIfPDFConvert[i].documentOrder;
        var fileManagerID = this.UploadingFilesCheckIfPDFConvert[i].FileManagerID;
        var projectDocumentID = 0;

        this.formData.append('MyDriveDocuments', projectDocumentID + '|' + documentName + '|' + fileManagerID + '|' + '0' + '|' + documentOrder);
      }

      else if (this.UploadingFilesCheckIfPDFConvert[i].action == 0 && this.UploadingFilesCheckIfPDFConvert[i].FillPlaceHolder == true) {
        var documentName = this.UploadingFilesCheckIfPDFConvert[i].fileName;
        var documenttype = this.UploadingFilesCheckIfPDFConvert[i].documentType;
        // var documenttype = this.UploadedFiles[i].file.name.split('.').pop();
        var documentOrder = this.UploadingFilesCheckIfPDFConvert[i].documentOrder;
        var projectDocumentID = 0;

        this.formData.append('PlaceholderDocuments', projectDocumentID + '|' + documentName + '|' + this.PlaceholderID + '|' + '0' + '|' + documentOrder);
      }

      else if ((this.UploadingFilesCheckIfPDFConvert[i].projectDocumentID == 0) && (this.UploadingFilesCheckIfPDFConvert[i].action == FileAction.Modify)) {

        var FullPath = this.UploadingFilesCheckIfPDFConvert[i].file.name;
        var documentNameSplit = FullPath.split('.');
        var documentName = documentNameSplit[0];
        //var documenttype = documentNameSplit[1];
        var documenttype = this.UploadingFilesCheckIfPDFConvert[i].file.name.split('.').pop();
        var documentOrder = this.UploadingFilesCheckIfPDFConvert[i].documentOrder;

         documentName=documentName.replace(/[,\#\[\]\(\)\{\}<>\/\\\|\?\*\":;!@\$%^&=~`'+]/g, '');

        // file region
        this.formData.append('files', this.UploadingFilesCheckIfPDFConvert[i].file);
        this.formData.append('filesData', documentName + '|' + documenttype + '|' + '0' + '|' + documentOrder);
      }

      else if (this.UploadingFilesCheckIfPDFConvert[i].action > 0) {
        let fileDetails = this.UploadingFilesCheckIfPDFConvert[i];
        if (fileDetails.projectDocumentID > 0) {
          this.formData.append('mdifiedDocuments', fileDetails.projectDocumentID + '|' + fileDetails.fileName + '|' + fileDetails.action + '|' + fileDetails.documentOrder);
        }
      }

      else if (this.UploadingFilesCheckIfPDFConvert[i].file == '' && this.UploadingFilesCheckIfPDFConvert[i].action == 0 && this.UploadingFilesCheckIfPDFConvert[i].FileManagerID == 0) {
        let fileDetails = this.UploadingFilesCheckIfPDFConvert[i];
        if (fileDetails.projectDocumentID > 0) {
          this.formData.append('mdifiedDocuments', fileDetails.projectDocumentID + '|' + fileDetails.fileName + '|' + 2 + '|' + fileDetails.documentOrder);
        }
      }
    }
    // return;
    this.formService.CheckIfPDFWillConvertToImage(this.formData).subscribe((response) => {
      if (response != undefined) {
        this.loaderService.hide();
        this.ResponseHolderDetails = response;
        if (this.ResponseHolderDetails) {
          this.toastr.success('Great News!  Your PDF Document will be prossessed and converted soon.', '', {
            timeOut: 5000,
          });
          this.isRemoveFile=false;        
        } else {
          this.loaderService.hide();
          this.toastr.error("Oops! This PDF Document is encrypted and can't be converted.  If you wish to use this Document, please (1) open the PDF outside of Flowtrics and go to the 'Print' feature.  Then (2) select 'Print to PDF' and it will save this document as a new file that you can use", '', {
            timeOut: 5000,
          });
          this.UploadedFiles=this.UploadedFiles.filter(m=>m.fileName!=this.UploadingFilesCheckIfPDFConvert[0].fileName);
          this.isRemoveFile=true;
        }
      } else {
        this.loaderService.hide();
      }
    });

  }

  compressFile(project) {
    const formData = new FormData();
    this.loaderService.show();
    formData.append('UserID', this.currentUser.UID);
    formData.append('OrganizationID', this.organizationId);
    formData.append('files', project.file);
    formData.append('DynamicDocumentId', project.dynamicDocumentId);
    this.formService.compressPDF(formData).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        this.loaderService.hide();
        if (this.responseHolder.data != null && this.responseHolder.status == this.statusConst.statusSuccess) {
          this.UploadedFiles.find((item) => item.dynamicDocumentId == project.dynamicDocumentId).Totalsize = this.responseHolder.data.fileDeatils[0].fileSize;
          this.UploadedFiles.find((item) => item.dynamicDocumentId == project.dynamicDocumentId).isCompressed = false;
          this.UploadedFiles.find((item) => item.dynamicDocumentId == project.dynamicDocumentId).documentPath = this.responseHolder.data.fileDeatils[0].documentPath;
          this.UploadedFiles.find((item) => item.dynamicDocumentId == project.dynamicDocumentId).size = this.responseHolder.data.fileDeatils[0].size;

          if (this.UploadedFiles.length > 0) {
            this.ShowNextButton = true;
            // var checkisCompressed=[];
            // checkisCompressed = this.UploadedFiles.filter(x => x.action !=FileAction.Delete && x.isCompressed == true);
            // if(checkisCompressed.length > 0){
            //    this.ShowNextButton = false;
            //  }else{
            //   this.ShowNextButton = true;
            // }
          } else {
            this.ShowNextButton = false;
            this.loaderService.hide();
          }
        } else {
          this.loaderService.hide();
        }
      } else {
        this.loaderService.hide();
      }
    });
  }

  retryPdfToImage(project) {
    let reqModel = {
      projectID: sessionStorage.getItem('projectID'),
      documentID: project.projectDocumentID,
      OrganizationID: Number(this.organizationId),
      DatabaseID: Number(this.databaseId),
      filePath: project.documentPath,
      type: Number(sessionStorage.getItem('type')),// 1 for Project and 2 for Template   
      OfficeID: this.myOfficeID,
      // UserID: this.currentUser.UID,
      createdBy: this.currentUser.UID
    }
    this.formService.retryPdfToImage(reqModel).subscribe(response => {
      if (response.status == this.statusConst.statusSuccess) {
        project.pdfToImageStatus = 3;
      }
    });
  }

  uploadFilesSimulator(index: number) {
    setTimeout(() => {
      index = 0;
      if (index === this.UploadingFiles.length) {
        this.InputFile.nativeElement.value = '';
        return;
      } else {
        const progressInterval = setInterval(() => {
          if (this.UploadingFiles.length > 0) {
            if (this.UploadingFiles[index].progress === 100) {
              clearInterval(progressInterval);
              var id = this.UploadedFiles.length;
              var req = {
                id: id + 1,//this.UploadingFiles[index].id+1,
                fileName: this.UploadingFiles[index].fileName,
                base64: this.UploadingFiles[index].base64,
                documentType: this.UploadingFiles[index].documentType,
                action: 0,
                isDeleted: false,
                projectDocumentID: 0,
                file: this.UploadingFiles[index].file,
                FileManagerID: 0,
                FillPlaceHolder: false,
                Totalsize: this.UploadingFiles[index].Totalsize,
                isCompressed: this.UploadingFiles[index].isCompressed,
                dynamicDocumentId: this.UploadingFiles[index].dynamicDocumentId,
                replaceDocumentId: this.replaceDocumentId
              };
              this.UploadedFiles.push(req);
              this.UploadingFiles.splice(index, 1);
              this.UploadedNewFiles = this.UploadedFiles;
              this.uploadFilesSimulator(index + 1);
              if (this.UploadingFiles.length == 0) {
                this.ShowNextButton = true;
                // var checkisCompressed=[];
                // checkisCompressed = this.UploadedNewFiles.filter(x => x.isCompressed == true);
                // if(checkisCompressed.length > 0){
                //   this.ShowNextButton = false;
                // }else{
                //   this.ShowNextButton = true;
                // }                
              }
            this.CheckIfPDFWillConvertToImage();
            } else {
              this.UploadingFiles[index].progress += 5;
            }
          }
        }, 100);
      }
    }, 500);
  }


  // deleteFile(file) {
  //   const index = this.UploadingFiles.indexOf(file);
  //   if (index >= 0) {
  //     this.UploadingFiles.splice(index, 1);
  //   }
  // }


  deleteFileFromUploaded(file) {
    // Modify 2,Delete 3
    const index = this.UploadedFiles.indexOf(file);
    if (index >= 0) {
      this.UploadedFiles.find((item) => item.id == file.id).action = FileAction.Delete;
      this.UploadedFiles.find((item) => item.id == file.id).isDeleted = true;
    }

    this.UploadedNewFiles = this.UploadedFiles.filter(x => x.action != FileAction.Delete);

    if (this.UploadedNewFiles.length > 0) {
      this.ShowNextButton = true;
      // var checkisCompressed=[];
      // checkisCompressed = this.UploadedFiles.filter(x => x.action !=FileAction.Delete && x.isCompressed == true);
      // if(checkisCompressed.length > 0){
      //    this.ShowNextButton = true;
      //  } else{
      //   this.ShowNextButton = true;
      //  }      
    } else {
      this.ShowNextButton = false;
      this.ImportTemplateShow = true;
    }
  }

  downloadPdf(file) {
    if (file.FileManagerID > 0) {
      this.DownloadSingleFileManager(file);
      return;
    }
    else if (file.projectDocumentID > 0) {
      this.DownloadSingleFile(file);
      return;
    }
    else if (file.projectDocumentID == 0 && file.FileManagerID != 0) {
      FileSaver.saveAs(file.base64, file.fileName);
      return;
    }
    else if (file.projectDocumentID == 0 && file.FileManagerID == 0 && !file.base64) {
      this.DownloadSingleFile(file);
      return;
    }
    else if (file.projectDocumentID == 0 && file.FileManagerID == 0 && file.base64) {
      FileSaver.saveAs(file.base64, file.fileName);
      return;
    }
  }

  DownloadSingleFileManager(doc: any) {
    this.loaderService.show();
    this.formService.getAttachment(doc.fileName, doc.filePath).subscribe((response) => {
      if (response !== undefined) {
        if(response.data.contentType==null){
          response.data.contentType="application/pdf";
        }
        const data = 'data:' + response.data.contentType + ';base64,' + response.data.base64URL;
        FileSaver.saveAs(data, doc.fileName);
        this.loaderService.hide();
      } else {
        this.loaderService.hide();
      }
    });
  }


  DownloadSingleFile(doc: any) {
    this.loaderService.show();
    this.formService.getAttachment(doc.fileName, doc.documentPath).subscribe((response) => {
      if (response !== undefined) {
        if(response.data.contentType==null){
          response.data.contentType="application/pdf";
        }
        const data = 'data:' + response.data.contentType + ';base64,' + response.data.base64URL;
        FileSaver.saveAs(data, doc.fileName);
        this.loaderService.hide();
      } else {
        this.loaderService.hide();
      }
    });
  }

  openDialogWithRef(templateRef: TemplateRef<any>, file) {
    this.editfilename.id = file.id;
    this.editfilename.filename = file.fileName;
    this.dialog.open(templateRef, {
      panelClass: 'selectParticipants',
    });
  }

  UpdateFileName() {
    // Modify 2,Delete ,3
    let file = this.editfilename;
    this.UploadedFiles;
    this.UploadedFiles.find((item) => item.id == file.id).fileName = file.filename;
    this.UploadedFiles.find((item) => item.id == file.id).action = FileAction.Modify;
    this.ShowNextButton = true;
    this.close();
  }

  GetProjectDocument(projectID: any, IsTemplate) {
    var ReqModel = {
      projectID: Number(projectID),
      type: Number(sessionStorage.getItem('type')),// 1 for Project and 2 for Template
      UserID: this.currentUser.UID,
      OrganizationID: Number(this.organizationId),
      DatabaseID: Number(this.databaseId),
      OfficeIDList: this.OfficeIDList,
      officeID: this.myOfficeID,
      isSent: (sessionStorage.getItem("isSent") == null || sessionStorage.getItem("isSent") == undefined) ? false : (sessionStorage.getItem("isSent") == 'true' ? true : false)
    };
    this.loaderService.show();
    this.formService.GetProjectDocuments(ReqModel).subscribe((response) => {
      if (response != undefined) {
        this.ResponseHolderDetails = response;
        if (this.ResponseHolderDetails.status == this.statusConst.statusSuccess) {
          sessionStorage.setItem('ProjectName', this.ResponseHolderDetails.data.project.projectName);
          this.projectName = this.ResponseHolderDetails.data.project.projectName;
          this.isProgressiveForm=this.ResponseHolderDetails.data.project.isProgressiveForm;
          this.selected3cType = this.ResponseHolderDetails.data.project.selected3cType == 1 ? true : false;
          this.stepCompleted = this.ResponseHolderDetails.data.project.stepCompleted;
          this.UploadedFiles = [];
          var ImportTemplateShow = sessionStorage.getItem('ImportTemplateShow');
          if (ImportTemplateShow == "false") {
            this.ImportTemplateShow = false;
          } else {
            this.ImportTemplateShow = true;
          }

          let data = response.data;
          this.project = data.project;
          this.projectDocuments = data.documents;

          this.projectDocuments.forEach((e) => {
            if(e.documentName!=null){
             var name = e.documentName.split('.');
             this.UploadedFiles.push({
              id: e.projectDocumentID,
              fileName: name[0],
              // fileName: name[0].substring(0, 30),               
              base64: '',
              documentType: e.fileType,
              documentPath: e.documentPath,
              action: 0,
              isDeleted: false,
              projectDocumentID: e.projectDocumentID,
              file: '',
              pdfToImageStatus: e.pdFtoImageStatus,
              FileManagerID: 0,
              FillPlaceHolder: false,
              isCompressed: false,
              Totalsize: e.fileSize,
              pageCount: e.pageCount
             });
            }           
          });
          if (this.UploadedNewFiles.length > 0) {
            this.UploadedNewFiles.forEach((e) => {
              this.UploadedFiles.push({
                id: e.id,
                fileName: e.fileName,//get first 5 chars //e.fileName,
                //fileName: e.fileName.substring(0, 30),//get first 5 chars //e.fileName,
                base64: e.base64,
                documentType: e.documentType,
                documentPath: '',
                action: e.action,
                isDeleted: e.isDeleted,
                projectDocumentID: e.projectDocumentID,
                file: e.file,
                //pdfToImageStatus:' ',
                FileManagerID: e.FileManagerID,
                FillPlaceHolder: e.FillPlaceHolder,
                Totalsize: e.Totalsize,
                isCompressed: e.isCompressed,
                dynamicDocumentId: e.dynamicDocumentId
              });
            });
          }
          if (IsTemplate == true) {
            this.UploadedFiles.forEach(e => {
              e.isTemplate = true;
            });
          } else {
            this.UploadedFiles.forEach(e => {
              e.isTemplate = false;
            });
          }
          this.UploadedNewFiles = this.UploadedFiles;
          if (this.UploadedNewFiles.length > 0) {
            this.ShowNextButton = true;
            // var checkisCompressed=[];
            // checkisCompressed = this.UploadedFiles.filter(x => x.action !=FileAction.Delete && x.isCompressed == true);
            // if(checkisCompressed.length > 0){
            //    this.ShowNextButton = true;
            //   }else{
            //   this.ShowNextButton = true;
            // }
          }
          if (this.UploadedNewFiles.length == 0) {
            this.ShowNextButton = false;
          }
          this.loaderService.hide();
        } else {
          this.ShowNextButton = false;
          this.loaderService.hide();
        }
      } else {
        this.ShowNextButton = false;
        this.loaderService.hide();
      }
    });
  }


  SubmitBackButton() {
    sessionStorage.setItem('MasterTemplatePDFForm', 'false');
    this._dataSharingService.sendSelectedFolderContentFromLeftMenu(null);
    this._dataSharingService.sendFillPlaceholderDocumentForCore("");
    this.router.navigate(['/esignature']);
  }

  onChange(searchValue: string) {
    this.projectName = searchValue;
    this.projectNameChange = true;
  }


  SubmitData() {
    if (sessionStorage.getItem('stepCompleted') == undefined || Number(sessionStorage.getItem('stepCompleted')) == 0)
      sessionStorage.setItem('stepCompleted', '1');
    if (this.UploadedFiles.length == 0) {
      this.toastr.warning('Please upload document.');
      return;
    }

    this.loaderService.show();
    this.formData= new FormData();
    if (sessionStorage.getItem('MasterTemplatePDFForm') == "true") {
      this.formData.append('IsMasterTemplate', 'true');
    } else {
      this.formData.append('IsMasterTemplate', 'false');
    }

    //this.formData.append('OfficeIDList', this.OfficeIDList);
    this.formData.append('officeID', this.myOfficeID);
    this.formData.append('UserID', this.currentUser.UID);
    this.formData.append('DatabaseID', this.databaseId);
    this.formData.append('OrganizationID', this.organizationId);
    if (sessionStorage.getItem('projectID') !== null && sessionStorage.getItem('projectID') !== undefined && sessionStorage.getItem('projectID') !== '0') {
      this.formData.append('ProjectID', sessionStorage.getItem('projectID'));
    }
    else {
      this.formData.append('ProjectID', '0');
    }
    if (this.selected3cType == true) {

    }
    this.formData.append('IsProgressiveForm', this.isProgressiveForm.toString());
    this.formData.append('TransactionType', this.TransactionType);
    this.formData.append('selected3cType', (this.selected3cType == true ? 1 : 0).toString());
    this.formData.append('PlaceholderID', this.PlaceholderID);
    this.formData.append('ProjectName', this.projectName); //sessionStorage.getItem('ProjectName')
    this.formData.append('ProjectType', (FormTypes.PdfForm).toString());
    this.formData.append('TransactionID', this.TransactionID);
    this.formData.append('Type', sessionStorage.getItem('type')); // 1 for Project and 2 for Template

    for (let i = 0; i < this.UploadedFiles.length; i++) {
      let index = this.UploadedFiles.findIndex(x => x.id === this.UploadedFiles[i].id);
      this.UploadedFiles.find((item) => item.id == this.UploadedFiles[i].id).documentOrder = (index + 1);
    }

    for (let i = 0; i < this.UploadedFiles.length; i++) {

      if (this.UploadedFiles[i].file !== '' && this.UploadedFiles[i].action == 0) {
        var FullPath = this.UploadedFiles[i].file.name;
        var documentNameSplit = FullPath.split('.');
        var documentName = documentNameSplit[0];
         documentName=documentName.replace(/[,\#\[\]\(\)\{\}<>\/\\\|\?\*\":;!@\$%^&=~`'+]/g, '');
        // var documenttype = documentNameSplit[1];
        var documenttype = this.UploadedFiles[i].file.name.split('.').pop();
        var documentOrder = this.UploadedFiles[i].documentOrder;
        var documentpath = this.UploadedFiles[i].documentPath ?? "";
        var documentsize = this.UploadedFiles[i].Totalsize ?? "";
        let replaceDocId = this.UploadedFiles[i].replaceDocumentId;
        // file region
        this.formData.append('files', this.UploadedFiles[i].file);
        if(replaceDocId>0)
        {
          this.formData.append('filesData', documentName + '|' + documenttype + '|' + '7' + '|' + documentOrder + '|' + documentpath + '|' + documentsize + '|' + replaceDocId);
        }
        else
        {
          this.formData.append('filesData', documentName + '|' + documenttype + '|' + '0' + '|' + documentOrder + '|' + documentpath + '|' + documentsize + '|0');
        }
      }

      else if (this.UploadedFiles[i].FileManagerID > 0 && this.UploadedFiles[i].action == 0) {
        var documentName = this.UploadedFiles[i].fileName;
        //var documenttype = this.UploadedFiles[i].documentType; 
        var documenttype = this.UploadedFiles[i].fileName.split('.').pop();
        var documentOrder = this.UploadedFiles[i].documentOrder;
        var fileManagerID = this.UploadedFiles[i].FileManagerID;
        var projectDocumentID = 0;

        this.formData.append('MyDriveDocuments', projectDocumentID + '|' + documentName + '|' + fileManagerID + '|' + '0' + '|' + documentOrder);
      }

      else if (this.UploadedFiles[i].action == 0 && this.UploadedFiles[i].FillPlaceHolder == true) {
        var documentName = this.UploadedFiles[i].fileName;
        var documenttype = this.UploadedFiles[i].documentType;
        // var documenttype = this.UploadedFiles[i].file.name.split('.').pop();
        var documentOrder = this.UploadedFiles[i].documentOrder;
        var projectDocumentID = 0;

        this.formData.append('PlaceholderDocuments', projectDocumentID + '|' + documentName + '|' + this.PlaceholderID + '|' + '0' + '|' + documentOrder);
      }

      else if ((this.UploadedFiles[i].projectDocumentID == 0) && (this.UploadedFiles[i].action == FileAction.Modify)) {

        var FullPath = this.UploadedFiles[i].file.name;
        var documentNameSplit = FullPath.split('.');
        var documentName = documentNameSplit[0];
        //var documenttype = documentNameSplit[1];
        var documenttype = this.UploadedFiles[i].file.name.split('.').pop();
        var documentOrder = this.UploadedFiles[i].documentOrder;

        documentName=documentName.replace(/[,\#\[\]\(\)\{\}<>\/\\\|\?\*\":;!@\$%^&=~`'+]/g, '');

        // file region
        this.formData.append('files', this.UploadedFiles[i].file);
        this.formData.append('filesData', documentName + '|' + documenttype + '|' + '0' + '|' + documentOrder);
      }

      else if (this.UploadedFiles[i].action > 0) {
        let fileDetails = this.UploadedFiles[i];
        if (fileDetails.projectDocumentID > 0) {
          this.formData.append('mdifiedDocuments', fileDetails.projectDocumentID + '|' + fileDetails.fileName + '|' + fileDetails.action + '|' + fileDetails.documentOrder);
        }
      }

      else if (this.UploadedFiles[i].file == '' && this.UploadedFiles[i].action == 0 && this.UploadedFiles[i].FileManagerID == 0) {
        let fileDetails = this.UploadedFiles[i];
        if (fileDetails.projectDocumentID > 0) {
          this.formData.append('mdifiedDocuments', fileDetails.projectDocumentID + '|' + fileDetails.fileName + '|' + 2 + '|' + fileDetails.documentOrder);
        }
      }
    }
    // return;
    this.formService.AddProjectStepFirst(this.formData).subscribe((response) => {
      if (response != undefined) {
        //this.loaderService.hide();
        this.ResponseHolderDetails = response;
        if (this.ResponseHolderDetails.status == this.statusConst.statusSuccess) {
          sessionStorage.setItem('projectID', response.data);
          setTimeout(() => {
            this._dataSharingService.sendFillPlaceholderDocumentForCore("");
            this.router.navigate(['/esignature/second']);
            this.loaderService.hide();
            this.UploadedFiles = [];
          }, 3000);

          // this.UploadedFiles = [];          
          // this._dataSharingService.sendFillPlaceholderDocumentForCore("");
          // this.router.navigate(['/esignature/second']);          
        } else {
          this.loaderService.hide();
        }
      } else {
        this.loaderService.hide();
      }
    });

  }


  SubmitNextButton() {
    this.ShowNextButton = false;
    var type = Number(sessionStorage.getItem('type'));
    this.projectFormId = Number(sessionStorage.getItem('projectID'));
    if (this.projectFormId != 0) {
      this.projectFormId = Number(sessionStorage.getItem('projectID'));
    } else {
      this.projectFormId = 0;
    }

    if (this.projectName == "" || this.projectName == undefined || this.projectName == null) {
      this.toastr.error('Please enter project name.', '', {
        timeOut: 2000,
      });
      this.ShowNextButton = true;
      return;
    }
    var checkisCompressed = [];
    checkisCompressed = this.UploadedFiles.filter(x => x.action != FileAction.Delete && x.isCompressed == true);
    // checkisCompressed = this.UploadedFiles.filter(x => x.isCompressed == true);
    if (checkisCompressed.length > 0) {
      this.toastr.warning('Please click on compress button on highlighted files to proceed.', '', {
        timeOut: 2000,
      });
      this.ShowNextButton = true;
      return;
    }

    if (sessionStorage.getItem('projectID') !== null && sessionStorage.getItem('projectID') !== undefined && sessionStorage.getItem('projectID') !== '0') {
      if (this.projectName == "" || this.projectName == undefined || this.projectName == null) {
        this.toastr.error('Please enter project name.', '', {
          timeOut: 2000,
        });
        this.ShowNextButton = true;
        return;
      } else {
        if (type == ProjectTempType.Project) {
          var req = {
            projectName: this.projectName.trim(),
            projectID: this.projectFormId,
            userID: this.currentUser.UID,
            organizationID: Number(this.organizationId),
            databaseID: Number(this.databaseId),
            officeID: this.myOfficeID,
          }
          this.formService.CheckProjectNames(req).subscribe((response) => {
            if (response != undefined) {
              this.responseHolder = response;
              if (this.responseHolder.data == false  && this.projectNameChange != false) {
                  this.toastr.warning(this.responseHolder.message, '', {
                   timeOut: 3000,
                  });
                // this.toastr.warning('Project name already exist.', '', {
                //   timeOut: 2000,
                // });
                this.ShowNextButton = true;
                return;
              } else {
                this.SubmitData();
                return;
              }
            } else {

            }
          });

        }
        if (type == ProjectTempType.Template) {
          this.SubmitData();
          return;
        }
        // if(type == 2){
        //   var obj = {
        //     formName:this.projectName.trim(),
        //     formtID: this.projectFormId,
        //     userID:this.currentUser.UID,
        //     organizationID:Number(this.organizationId),
        //     databaseID:Number(this.databaseId),
        //   }
        //   this.formService.CheckProjectTemplateName(obj).subscribe((response) => {
        //      if (response != undefined) {
        //       this.SubmitData();
        //       this.responseHolder = response;
        //        if (this.responseHolder.status == this.statusConst.statusSuccess && this.responseHolder.data != null) {         
        //          this.toastr.warning('Template name already exist.', '', {
        //           timeOut: 2000,
        //         }); 
        //         } else {
        //           this.SubmitData();
        //         }
        //       } else {
        //       }
        //     });    
        // }

      }
    }

    var projectID = sessionStorage.getItem('projectID');
    if (projectID == null || projectID == undefined || projectID == '0' || projectID == "") {
      if (type == ProjectTempType.Project) {
        var req = {
          projectName: this.projectName.trim(),
          projectID: this.projectFormId,
          userID: this.currentUser.UID,
          organizationID: Number(this.organizationId),
          databaseID: Number(this.databaseId),
          officeID: this.myOfficeID,
        }
        this.formService.CheckProjectNames(req).subscribe((response) => {
          if (response != undefined) {
            this.responseHolder = response;
            if (this.responseHolder.data == false && this.projectNameChange != false) {
                this.toastr.warning(this.responseHolder.message, '', {
                   timeOut: 3000,
                  });
              // this.toastr.warning('Project name already exist.', '', {
              //   timeOut: 2000,
              // });
              this.ShowNextButton = true;
              return;
            } else {
              this.SubmitData();
              return;
            }
          } else {

          }
        });
      }

      if (type == ProjectTempType.Template) {
        this.SubmitData();
        return;
        //   var obj = {
        //     formName:this.projectName.trim(),
        //     formtID: this.projectFormId,
        //     userID:this.currentUser.UID,
        //     organizationID:Number(this.organizationId),
        //     databaseID:Number(this.databaseId),
        //   }
        //   this.formService.CheckProjectTemplateName(obj).subscribe((response) => {
        //      if (response != undefined) {
        //       this.responseHolder = response;
        //        if (this.responseHolder.status == this.statusConst.statusSuccess && this.responseHolder.data != null) {         
        //          this.toastr.warning('Template name already exist.', '', {
        //           timeOut: 2000,
        //         }); 
        //         } else {
        //           this.SubmitData();
        //         }
        //       } else {
        //       }
        //     });    
      }
    }

  }


  drop(event: CdkDragDrop<string[]>) {
    moveItemInArray(this.UploadedFiles, event.previousIndex, event.currentIndex);
  }

  close() {
    this.searchKey="";
    this.formDialog.reset();
    this.dialog.closeAll();
    // For Import Template // 
    this.dataSource.data = [];
    this.menuHeader = [];
    this.FormFolderListMiddleSection = [];
    this.FormFolderList = [];
    this.activeNode = "";
    this.SharedWithMeactive = false;
    this.selectButtonShow = false;

    // For My Drive // 
    this.menuHeaderMyDrive = [];
    this.MyDrivefoldersList = [];
    this.FileManagerFolderListLeft = [];
    this.activeNodeFileManager = "";
    this.selectButtonMyDriveShow = false;
  }

  selectForm(templateRef: TemplateRef<any>) {
    this.dialog.open(templateRef, {
      panelClass: 'selectTemplate',
    });

    this.activeNode = "";
    this.selectButtonShow = false;
    this.isShowForm = true;
    this.isSharedWithMe = false;
    this.FormFolderListMiddleSection = [];
    this.selectButtonShow = false;
    this.SharedWithMeactive = false;
    this.menuHeaderMyDrive = [];
    this.menuHeader = []
    this.MyDrivefoldersList = [];
    this.FileManagerFolderListLeft = [];
    this.getFormFolderListLeftPanel();
    this.getFormFolderListMiddlePanel();
  }

  selectDrive(templateRef: TemplateRef<any>) {
    this.dialog.open(templateRef, {
      panelClass: 'selectTemplate',
    });
    this.searchKey="";
    this.activeNodeFileManager = "";
    this.MyDrivefoldersList = [];
    this.FileManagerFolderListLeft = [];
    this.isShowMyDrive = true;
    this.isSharedWithMeMyDrive = false;
    this.SharedWithMeMyDriveactive = false;
    this.menuHeaderMyDrive = [];
    this.menuHeader = [];
    this.fileSizeFromMyDrive = "";
    this.getFileManagerFoldersList(0);
    this.getFileManagerFolderList();
  }


  // =========== For Shared with me  =========// 

  getSharedWithMe() {
    var ReqModel = {
      formFolderID: 0,
      formFolderName: "",
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      OfficeID: this.myOfficeID,
      databaseID: Number(this.databaseId),
    }
    this.formService.getFormFolderSharedWithMeList(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConst.statusSuccess && this.responseHolder.data != null) {
          this.SharedWithMeFormFolderList = this.responseHolder.data;
          this.SharedWithMeFormFolderList.forEach(e => {
            e.isChecked = false
          });
          if (this.SharedWithMeFormFolderList != null) {
            this.SharedWithMeFormFolderList.map((res) => {
              if (res.sharedbyFirstName != null) {
                res.sharedbyFirstName = this.encryptionAlgo.get(this.reusableClass.decryptionKey, res.sharedbyFirstName);
              }
              if (res.sharedbyLastName != null) {
                res.sharedbyLastName = this.encryptionAlgo.get(this.reusableClass.decryptionKey, res.sharedbyLastName);
              }
              return res;
            });
          }
          this.isShowForm = false;
          this.isSharedWithMe = true;
          this.SharedWithMeactive = true;
          this.selectButtonShow = false;
          this.activeNode = "";
          this.menuHeader = [];
          this.parentID = 0;
        }
        else {
          this.isShowForm = false;
          this.isSharedWithMe = true;
          this.SharedWithMeactive = true;
          this.selectButtonShow = false;
          this.activeNode = "";
          this.menuHeader = [];
          this.parentID = 0;
          this.SharedWithMeFormFolderList = [];
        }
      }
      else {
      }
    });
  }


  breadCrumbMainSHaredWithMeClick() {
    this.selectButtonShow = false;
    this.getSharedWithMe();
    this.menuHeader = [];
    this.parentID = 0;
  }


  getFormFolderWithFormTemplatesSharedWithMe(form) {
    this.TypeId = form.type;
    var type = form.type;
    //{ 1- Folder, 2- Form}
    if (type == 1) {
      var ReqModel = {
        formFolderID: form.id,
        formFolderName: '',
        permissionType: form.permissionType,
        userID: this.currentUser.UID,
        organizationID: Number(this.organizationId),
        OfficeID: this.myOfficeID,
        databaseID: Number(this.databaseId),
      };
      this.formService.getFormFolderWithFormTemplatesSharedWithMe(ReqModel).subscribe((response) => {
        if (response != undefined) {
          this.responseHolder = response;
          if (this.responseHolder.status == this.statusConst.statusSuccess) {
            this.SharedWithMeFormFolderList = this.responseHolder.data;
            if (this.SharedWithMeFormFolderList != null) {
              this.SharedWithMeFormFolderList.map((res) => {
                if (res.sharedbyFirstName != null) {
                  res.sharedbyFirstName = this.encryptionAlgo.get(this.reusableClass.decryptionKey, res.sharedbyFirstName);
                }
                if (res.sharedbyLastName != null) {
                  res.sharedbyLastName = this.encryptionAlgo.get(this.reusableClass.decryptionKey, res.sharedbyLastName);
                }
                return res;
              });
            }
            this.parentID = form.id;
            this.menuHeader.push({
              label: form.name,
              id: form.id,
              icon: 'navigate_next',
              permissionType: form.permissionType,
            });
            this.menuHeader = this.menuHeader.filter((thing, i, arr) => arr.findIndex((t) => t.id === thing.id) === i);
          } else {
          }
        } else {
        }
      });
    } else {
    }
  }

  GetAllForms() {
    this.activeNode = "";
    this.dataSource.data = [];
    this.selectButtonShow = false;
    this.isShowForm = true;
    this.isSharedWithMe = false;
    this.SharedWithMeactive = false;
    this.menuHeader = [];
    this.getFormFolderListLeftPanel();
    this.getFormFolderListMiddlePanel();
  }

  // For Import Template // 


  getFormFolderListLeftPanel() {
    var ReqModel = {
      formFolderID: 0,
      formFolderName: "",
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      OfficeID: this.myOfficeID,
      databaseID: Number(this.databaseId),
    }
    this.loaderService.show();
    this.formService.getFormFolderList(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConst.statusSuccess && this.responseHolder.data != null) {
          this.loaderService.hide();
          this.FormFolderList = this.responseHolder.data;
          if (this.FormFolderList.length > 0) {
            this.dataSource.data = this.FormFolderList;
          }
        }
        else {
          this.loaderService.hide();
        }
      }
      else {
        this.loaderService.hide();
      }
    });

  }

  getFormFolderListMiddlePanel() {
    var ReqModel = {
      formFolderID: 0,
      formFolderName: '',
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      OfficeID: this.myOfficeID,
      databaseID: Number(this.databaseId),
    };
    this.formService.getFormFolderWithFormTemplates(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConst.statusSuccess && this.responseHolder.data != null) {
          this.FormFolderListMiddleSection = this.responseHolder.data.filter(x => x.formType != 3); //For HTML Form
          // this.FormFolderListMiddleSection = this.responseHolder.data;
          this.FormFolderListMiddleSection.forEach(e => {
            e.isChecked = false
          });
        } else {
        }
      } else {
      }
    });

  }


  getform(form, FormOrSharedWithMe) {
    if (FormOrSharedWithMe == "MyForm") {
      this.activeNode = form.id;
    }
    if (FormOrSharedWithMe == "SharedWithMe") {
      this.activeNode = "";
    }
    this.TypeId = form.type;
    var type = form.type;

    //{ 1- Folder, 2- Form}
    if (type == 1) {
      var ReqModel = {
        formFolderID: form.id,
        formFolderName: '',
        userID: this.currentUser.UID,
        organizationID: Number(this.organizationId),
        OfficeID: this.myOfficeID,
        databaseID: Number(this.databaseId),
      };
      this.formService.getFormFolderWithFormTemplates(ReqModel).subscribe((response) => {
        if (response != undefined) {
          this.responseHolder = response;
          if (this.responseHolder.status == this.statusConst.statusSuccess) {
            this.FormFolderListMiddleSection = this.responseHolder.data.filter(x => x.formType != 3); //For HTML Form
            // this.FormFolderListMiddleSection = this.responseHolder.data;
            this.parentID = form.id;

            this.menuHeader.push({
              label: form.name,
              id: form.id,
              icon: 'navigate_next',
            });
            this.menuHeader = this.menuHeader.filter((thing, i, arr) => arr.findIndex((t) => t.id === thing.id) === i);
          } else {
          }
        } else {
        }
      });
    } else {
    }
  }


  breadCrumbMainClick() {
    this.FormFolderListMiddleSection = [];
    // this.getFormFolderListLeftPanel();
    this.getFormFolderListMiddlePanel();
    this.menuHeader = [];
    this.TypeId = 0;
    this.parentID = 0;
    this.selectButtonShow = false;
    this.activeNode = "";
  }

  breadCrumb(menu, index) {
    this.menuHeader.splice(index + 1, this.menuHeader.length - 1);
    if (menu[index] && menu[index].items && menu[index].items.length) {
      this.FormFolderList = menu[index].items;
    }
    var data = this.menuHeader[index];
    this.getformnavigate(data);
    this.selectButtonShow = false;
    this.parentID = data.id;
  }

  getformnavigate(form) {
    this.selectButtonShow = false;
    this.activeNode = form.id;
    var ReqModel = {
      formFolderID: form.id,
      formFolderName: '',
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      OfficeID: this.myOfficeID,
      databaseID: Number(this.databaseId),
    };
    this.formService.getFormFolderWithFormTemplates(ReqModel).subscribe((response) => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          // this.FormFolderListMiddleSection = this.responseHolder.data;
          this.FormFolderListMiddleSection = this.responseHolder.data.filter(x => x.formType != 3); //For HTML form            
        } else {
        }
      } else {
      }
    });
  }

  getIsFavorite(isFavorite) {
    isFavorite = isFavorite.isFavorite;
    return isFavorite;
  }

  radioChange(form, FormOrShared) {
    if (FormOrShared == "SharedWithMe") {
      this.activeNode = "";
      this.SharedWithMeFormFolderList.forEach(e => {
        e.isChecked = false
      });
    }
    if (FormOrShared == "MyForm") {
      this.FormFolderListMiddleSection.forEach(e => {
        e.isChecked = false
      });
    }
    if (form.type == 1 && FormOrShared == "MyForm") {
      this.selectButtonShow = false;
      this.getform(form, FormOrShared);
    }

    if (form.type == 2) {
      this.PlaceholderName = form.name;
      this.FormID = form.id;
      this.selectButtonShow = true;

      if (FormOrShared == "MyForm") {
        this.FormFolderListMiddleSection.forEach(e => {
          if (e.id == form.id) {
            e.isChecked = true
          }
        });
      }
      if (FormOrShared == "SharedWithMe") {
        this.SharedWithMeFormFolderList.forEach(e => {
          if (e.id == form.id) {
            e.isChecked = true
          }
        });
      }
    }
  }

  // ======= Left Panel FormFolderList Quick Form and Import Form ========//

  getFormFolderWithTemplatesLeftPanel(form) {
    this.selectButtonShow = false;
    this.activeNode = form.formFolderID;
    var ReqModel = {
      formFolderID: form.formFolderID,
      formFolderName: "",
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      OfficeID: this.myOfficeID,
      databaseID: Number(this.databaseId),
    }
    this.formService.getFormFolderWithFormTemplates(ReqModel).subscribe(res => {
      if (res != undefined) {
        this.responseHolder = res;
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          this.FormsubFolderFolderList = this.responseHolder.data.filter(x => x.formType != 3); // for Html Form
          //  this.FormsubFolderFolderList = this.responseHolder.data;
          this.formService.GetParentFormFolderHierarchy(ReqModel).subscribe(response => {
            if (response != undefined) {
              if (response.status == this.statusConst.statusSuccess) {
                this.hierarchyList = response.data.hierarchy;
                if (this.hierarchyList == null || this.hierarchyList == undefined) {
                  this.breadCrumMenu = [];
                  this.menuHeader = this.breadCrumMenu;
                  this.FormFolderListMiddleSection = this.FormsubFolderFolderList;
                  this.parentID = form.parentID;
                } else {
                  this.breadCrumMenu = [];
                  this.hierarchyList.forEach(e => {
                    this.breadCrumMenu.push({ label: e.formFolderName, id: e.formFolderID, icon: 'navigate_next' });
                  });
                  this.menuHeader = this.breadCrumMenu;
                  this.FormFolderListMiddleSection = this.FormsubFolderFolderList;
                  this.parentID = form.parentID;
                  this.isShowForm = true;
                  this.isSharedWithMe = false;
                  this.SharedWithMeactive = false;
                }
              }
            }
          });
        }
        else {
        }
      }
      else {
      }
    });
  }

  ImportTemplateShow: boolean = true;

  SelectTemplateMergeSubmit() {
    if (Number(sessionStorage.getItem('type')) == 1) {
      //project
      this.SelectTemplateSubmit();
    } else {
      //form
      this.MergeTemplate();
    }
  }

  MergeTemplate() {
    this.dialog.closeAll();
    var ReqModel = {
      formFolderId: 0,
      formID: sessionStorage.getItem('projectID'), //edit
      newFormID: this.FormID, //new
      formName: this.PlaceholderName,
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId),
      officeID: this.myOfficeID,
    };
    this.loaderService.show();
    this.formService.MergeTemplate(ReqModel).subscribe((response) => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          this.loaderService.hide();
          this.UploadedNewFiles = [];
          this.GetProjectDocument(sessionStorage.getItem('projectID'), true);
        } else {
          this.loaderService.hide();
        }
      } else {
        this.loaderService.hide();
      }
    });
  }

  SelectTemplateSubmit() {
    this.dialog.closeAll();
    var ReqModel = {
      formFolderId: 0,
      formId: this.FormID,
      formName: this.PlaceholderName,
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId),
      OfficeIDList: this.OfficeIDList,
      officeID: this.myOfficeID,
    };
    this.loaderService.show()
    this.formService.UseFormsTemplateForProject(ReqModel).subscribe((response) => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          this.loaderService.hide();
          this.ImportTemplateShow = false;
          this.activeNode = "";
          sessionStorage.setItem('ImportTemplateShow', 'false');
          sessionStorage.setItem('projectID', response.data.projectID);
          sessionStorage.setItem('type', (ProjectTempType.Project).toString());
          this.GetProjectDocument(sessionStorage.getItem('projectID'), true);
        } else {
          this.loaderService.hide();
        }
      } else {
        this.loaderService.hide();
      }
    });
  }



  // ===== My Drive ======//

  breadCrumbMyDriveMainClick() {
    this.MyDrivefoldersList = [];
    this.FileManagerFolderListLeft = [];
    this.menuHeaderMyDrive = [];
    this.activeNodeFileManager = "";
    this.getFileManagerFoldersList(0);
    //this.getFileManagerFolderList(); 
    this.selectButtonMyDriveShow = false;
    this.foldersMyDriveListShow = false;
  }

  breadCrumbMyDrive(menu, index) {
    this.selectButtonMyDriveShow = false;
    this.menuHeaderMyDrive.splice(index + 1, this.menuHeaderMyDrive.length - 1);
    if (menu[index] && menu[index].items && menu[index].items.length) {
      this.MyDrivefoldersList = menu[index].items;
    }
    this.foldersMyDriveListShow = false;
    var data = this.menuHeaderMyDrive[index];
    this.getFileManagerFoldersList(data.id);
  }

  radioChangeMyDrive(form) {
    if (form.isFile == false) {
      this.MyDrivefoldersList.forEach(e => {
        e.isChecked = false
      });
      this.selectButtonMyDriveShow = false;
      this.showChildFolders(form);
      return;
    }
    if (form.isFile == true) {
      if (form.fileType != null || form.fileType != "" || form.fileType != undefined) {
        if (form.fileType != "pdf") {
          this.MyDrivefoldersList.forEach(e => {
            e.isChecked = false
          });
          this.toastr.warning('please select only pdf file.', '', {
            timeOut: 3000,
          });
          this.selectButtonMyDriveShow = false;
          return;
        }
        else {
          this.MyDrivefoldersList.forEach(e => {
            e.isChecked = false
          });

          this.selectButtonMyDriveShow = true;
          this.PlaceholderName = form.name;
          this.filePath = form.azureblobPath;
          if (form.fileSize) {
            this.fileSizeFromMyDrive = form.fileSize;
          } else {
            this.fileSizeFromMyDrive = "";
          }

          this.MyDrivefoldersList.forEach(e => {
            if (e.fileManagerItemID == form.fileManagerItemID) {
              e.isChecked = true
            }
          });

          this.fileManagerID = form.fileManagerItemID;
        }
      }
      if (form.fileType == null || form.fileType == "" || form.fileType == undefined) {
        var fileName = form.name.split('.').pop();
        if (fileName != "pdf") {
          this.MyDrivefoldersList.forEach(e => {
            e.isChecked = false
          });
          this.toastr.warning('please select only pdf file.', '', {
            timeOut: 3000,
          });
          this.selectButtonMyDriveShow = false;
          return;
        }
        else {
          this.MyDrivefoldersList.forEach(e => {
            e.isChecked = false
          });

          this.selectButtonMyDriveShow = true;
          this.PlaceholderName = form.name;
          this.filePath = form.azureblobPath;

          this.MyDrivefoldersList.forEach(e => {
            if (e.fileManagerItemID == form.fileManagerItemID) {
              e.isChecked = true
            }
          });
          this.fileManagerID = form.fileManagerItemID;
        }
      }
    }
  }

  getFileManagerFoldersList(folderId) {
    var reqModel = {
      fileManagerItemID: folderId,
      name: this.searchKey,
      pageIndex: 0,
      pageSize: 0,
      userID: this.currentUser.UID,
      officeID: this.myOfficeID,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId),
    }
    this.formService.FileManagerItemsWithHierarchy(reqModel).subscribe(response => {
      if (response.status == this.statusConst.statusSuccess) {
        this.MyDrivefoldersList = response.data.children;
        this.hierarchyList = response.data.hierarchy;
        if (this.hierarchyList == null || this.hierarchyList == null) {
          this.menuHeaderMyDrive = [];
        } else {
          this.menuHeaderMyDrive = [];
          this.hierarchyList.forEach(e => {
            this.menuHeaderMyDrive.push({ label: e.name, id: e.fileManagerItemID, icon: 'navigate_next' });
          });
        }

        this.MyDrivefoldersList.forEach(e => {
          e.isChecked = false;
        });
        if (this.MyDrivefoldersList == null || this.MyDrivefoldersList.length == 0) {
          this.MyDrivefoldersList = [];
          this.foldersMyDriveListShow = true;
        } else {
          this.foldersMyDriveListShow = false;
        }
      }
    });
  }


  getFileManagerFolderList() {
    var reqModel = {
      folderID: 0,
      folderName: "",
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId),
      officeID: this.myOfficeID,
      officeIDList: this.OfficeIDList
    }
    this.formService.getFoldersListForFML(reqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConst.statusSuccess && this.responseHolder.data != null) {
          this.FileManagerFolderListLeft = this.responseHolder.data.data;
          if (this.FileManagerFolderListLeft != null && this.FileManagerFolderListLeft != undefined) {
            this.dataSourceFileManager.data = this.FileManagerFolderListLeft;
          }
        }
        else {
        }
      }
      else {
      }
    });

  }


  showChildFolders(folder) {
    this.isShowMyDrive = true;
    this.isSharedWithMeMyDrive = false;
    this.selectButtonMyDriveShow = false;
    this.SharedWithMeMyDriveactive = false;
    this.activeNodeFileManager = folder.fileManagerItemID;
    this.getFileManagerFoldersList(folder.fileManagerItemID);
  }

  AddDocumentfromMyDrive() {
    this.PlaceholderName;
    this.fileManagerID;
    this.filePath;
    //var ext =  this.PlaceholderName.split('.').pop();
    var fileName = this.PlaceholderName.split('.');
    var filepaths = this.filePath.split('.');


    var id = this.UploadedFiles.length;
    var req = {
      id: id + 1,//this.UploadingFiles[index].id+1,
      fileName: fileName[0], //get first 30 chars //fileName[0],
      //  fileName: fileName[0].substring(0, 30), //get first 30 chars //fileName[0],
      filePath: this.filePath,
      base64: "",
      documentType: filepaths[3],
      action: 0,
      isDeleted: false,
      projectDocumentID: 0,
      file: "",
      FileManagerID: this.fileManagerID,
      FillPlaceHolder: false,
      Totalsize: this.fileSizeFromMyDrive ?? ""
    };
    this.UploadedFiles.push(req);
    this.UploadedNewFiles = this.UploadedFiles;
    if (this.UploadedNewFiles.length > 0) {
      this.ShowNextButton = true;
      // var checkisCompressed=[];
      // checkisCompressed = this.UploadedFiles.filter(x => x.action !=FileAction.Delete && x.isCompressed == true);
      // if(checkisCompressed.length > 0){
      //    this.ShowNextButton = false;
      //   }else{
      //   this.ShowNextButton = true;
      // }
    } else {
      this.ShowNextButton = false;
    }
    this.dialog.closeAll();
  }

   CheckcanThisPdfOpenforModifyByUrl(){
     var ReqModel = {
     
    }
    this.formService.canThisPdfOpenforModifyByUrl(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
                   
         }
        else {
        
        }
      }
      else {
      }
    });
  }


  // ===== Shared with me My Drive ======//

  breadCrumbMainSHaredWithMeMyDriveClick() {
    this.selectButtonMyDriveShow = false;
    this.menuHeaderMyDrive = [];
    this.getSharedWithMeMyDrive();
  }

  breadCrumbSharedWithMeMyDrive(menu, index) {
    this.selectButtonMyDriveShow = false;
    this.menuHeaderMyDrive.splice(index + 1, this.menuHeaderMyDrive.length - 1);
    if (menu[index] && menu[index].items && menu[index].items.length) {
      this.MyDrivefoldersList = menu[index].items;
    }
    this.foldersMyDriveListShow = false;
    var data = this.menuHeaderMyDrive[index];
    this.showChildFoldersSharedWithMeMyDrive({ type: 1, id: data.id, isFile: data.isFile, name: data.label });
  }

  GetAllMyDrive() {
    this.activeNodeFileManager = "";
    this.dataSourceFileManager.data = [];
    this.selectButtonMyDriveShow = false;
    this.isShowMyDrive = true;
    this.isShowForm = false;
    this.isSharedWithMe = false;
    this.isSharedWithMeMyDrive = false;
    this.SharedWithMeactive = false;
    this.SharedWithMeMyDriveactive = false;
    this.menuHeader = [];
    this.menuHeaderMyDrive = [];
    this.getFileManagerFoldersList(0);
    this.getFileManagerFolderList();
  }

  getSharedWithMeMyDrive() {
    var ReqModel = {
      fileManagerItemID: 0,
      name: "",
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId),
      officeID: this.myOfficeID,
      permissionType: 0
    }
    this.formService.GetSharedWithMeFileManager(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConst.statusSuccess && this.responseHolder.data != null) {
          this.SharedWithMeMyDriveFolderList = this.responseHolder.data;
          this.SharedWithMeMyDriveFolderList.forEach(e => {
            e.isChecked = false
          });
          if (this.SharedWithMeMyDriveFolderList != null) {
            this.SharedWithMeMyDriveFolderList.map((res) => {
              if (res.sharedbyFirstName != null) {
                res.sharedbyFirstName = this.encryptionAlgo.get(this.reusableClass.decryptionKey, res.sharedbyFirstName);
              }
              if (res.sharedbyLastName != null) {
                res.sharedbyLastName = this.encryptionAlgo.get(this.reusableClass.decryptionKey, res.sharedbyLastName);
              }
              return res;
            });
          }
          this.selectButtonMyDriveShow = false;
          this.isShowForm = false;
          this.isSharedWithMe = false;
          this.isShowMyDrive = false;
          this.isSharedWithMeMyDrive = true;
          this.SharedWithMeactive = false;
          this.SharedWithMeMyDriveactive = true;
          this.activeNode = "";
          this.activeNodeFileManager = "";
          this.menuHeader = [];
          this.menuHeaderMyDrive = [];
          this.foldersMyDriveListShow = false;
          this.parentID = 0;
        }
        else {
          this.selectButtonMyDriveShow = false;
          this.isShowForm = false;
          this.isSharedWithMe = false;
          this.isShowMyDrive = false;
          this.isSharedWithMeMyDrive = true;
          this.SharedWithMeactive = false;
          this.SharedWithMeMyDriveactive = true;
          this.activeNode = "";
          this.activeNodeFileManager = "";
          this.menuHeader = [];
          this.menuHeaderMyDrive = [];
          this.SharedWithMeMyDriveFolderList = [];
          this.foldersMyDriveListShow = false;
          this.parentID = 0;
        }
      }
      else {
      }
    });
  }

  showChildFoldersSharedWithMeMyDrive(folder) {
    this.isShowMyDrive = false;
    this.isSharedWithMeMyDrive = false;
    this.selectButtonMyDriveShow = false;
    this.isSharedWithMeMyDrive = true;
    this.SharedWithMeMyDriveactive = true;
    var folderId;
    if (folder.isFile == true) {
      this.menuHeaderMyDrive = [];
    }
    if (folder.fileManagerItemID == undefined) {
      folderId = folder.id;
    }
    if (folder.fileManagerItemID != undefined) {
      folderId = folder.fileManagerItemID;
    }

    this.menuHeaderMyDrive.push({
      label: folder.name,
      id: folderId,
      icon: 'navigate_next',
      isFile: folder.isFile
    });
    this.menuHeaderMyDrive = this.menuHeaderMyDrive.filter((thing, i, arr) => arr.findIndex((t) => t.id === thing.id) === i);
    this.ChildFoldersSharedWithMeMyDrive(folder);
  }

  ChildFoldersSharedWithMeMyDrive(folder) {
    var folderId;
    if (folder.fileManagerItemID == undefined) {
      folderId = folder.id;
    }
    if (folder.fileManagerItemID != undefined) {
      folderId = folder.fileManagerItemID;
    }
    var reqModel = {
      fileManagerItemID: folderId,
      name: "",
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId),
      officeID: this.myOfficeID,
      permissionType: 0
    }
    this.formService.GetSharedWithMeFileManagerWithHierarchy(reqModel).subscribe(response => {
      if (response.status == this.statusConst.statusSuccess) {
        this.SharedWithMeMyDriveFolderList = response.data;//.children;
        if (this.SharedWithMeMyDriveFolderList != null) {
          this.SharedWithMeMyDriveFolderList.map((res) => {
            if (res.sharedbyFirstName != null) {
              res.sharedbyFirstName = this.encryptionAlgo.get(this.reusableClass.decryptionKey, res.sharedbyFirstName);
            }
            if (res.sharedbyLastName != null) {
              res.sharedbyLastName = this.encryptionAlgo.get(this.reusableClass.decryptionKey, res.sharedbyLastName);
            }
            return res;
          });
        }
        if (this.SharedWithMeMyDriveFolderList == null || this.SharedWithMeMyDriveFolderList.length == 0) {
          this.SharedWithMeMyDriveFolderList = [];
        }
      } else {

      }
    });
  }


  radioChangeMyDriveSharedWithMe(form) {
    var folderId;
    if (form.isFile == false) {
      if (form.fileManagerItemID == undefined) {
        folderId = form.id;
      }
      if (form.fileManagerItemID != undefined) {
        folderId = form.fileManagerItemID;
      }
      this.menuHeaderMyDrive.push({
        label: form.name,
        id: folderId,
        icon: 'navigate_next',
        isFile: form.isFile
      });
      this.menuHeaderMyDrive = this.menuHeaderMyDrive.filter((thing, i, arr) => arr.findIndex((t) => t.id === thing.id) === i);
      this.ChildFoldersSharedWithMeMyDrive(form);
      return;
    }


    if (form.isFile == true) {
      if (form.fileType != "pdf") {
        this.SharedWithMeMyDriveFolderList.forEach(e => {
          e.isChecked = false
        });
        this.toastr.warning('please select only pdf file.', '', {
          timeOut: 3000,
        });
        this.selectButtonMyDriveShow = false;
        return;
      }

      this.selectButtonMyDriveShow = true;
      // this.PlaceholderName = form.name.substring(0, 30);//form.name; //get first 30 chars
      this.PlaceholderName = form.name;//form.name; //get first 30 chars
      this.PlaceholderID = "0";
      if (form.azureblobPath == null || form.azureblobPath == undefined) {
        this.filePath = form.url;
      }
      if (form.url == null || form.url == undefined) {
        this.filePath = form.azureblobPath;
      }
      if (form.fileSize) {
        this.fileSizeFromMyDrive = form.fileSize;
      }
      if (!form.fileSize) {
        this.fileSizeFromMyDrive = "";
      }

      this.SharedWithMeMyDriveFolderList.forEach(e => {
        e.isChecked = false;
      });

      if (form.fileManagerItemID == undefined) {
        this.fileManagerID = form.id;
        this.SharedWithMeMyDriveFolderList.forEach(e => {
          if (e.id == form.id) {
            e.isChecked = true;
          }
        });
      }
      if (form.fileManagerItemID != undefined) {
        this.fileManagerID = form.fileManagerItemID;
        this.SharedWithMeMyDriveFolderList.forEach(e => {
          if (e.fileManagerItemID == form.fileManagerItemID) {
            e.isChecked = true;
          }
        });
      }
    }

  }

  //=====================//

  searchKey:string="";

  Search(filterKey):void{
    if(filterKey!=="*"){
      this.searchKey = filterKey;
    }     
    if(filterKey!=""){
      if(filterKey=="*"){
        filterKey="";
      }           
      this.getFileManagerFoldersList(0);
  }else{
    this.searchKey="";     
    this.getFileManagerFoldersList(0);
   }    
  }

  SearchFilter(){
    if(this.searchKey!=""){       
     this.getFileManagerFoldersList(0,);
   }else{
    this.searchKey="";
    this.getFileManagerFoldersList(0);
   }  
  }



}


interface FoodNode {
  formFolderName: string;
  children?: FoodNode[];
  formFolderID: number;
  parentID: number;
  isShared: boolean;
}


/** Flat node with expandable and level information */
interface ExampleFlatNode {
  expandable: boolean;
  formFolderName: string;
  level: number;
  formFolderID: number;
  parentID: number;
  isShared: boolean;
}


interface FoodNodeFileManager {
  name: string;
  children?: FoodNodeFileManager[];
  fileManagerItemID: number;
  parentID: number;
  isShared: boolean;
}


interface ExampleFlatNodeFileManager {
  expandable: boolean;
  name: string;
  level: number;
  fileManagerItemID: number;
  parentID: number;
  isShared: boolean;
}

